import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import { v4 as uuid } from 'uuid';
import { ACTIVE_TAB } from '../../../shared/utils/constants';

const NavigationTabs = ({ children, step, nextStep, dto }) => {
  const [activeTab, setActiveTab] = useState(step);

  useEffect(() => {
    setActiveTab(step);
  }, [step]);

  return (
    <div className="tabs tabs--justify tabs--bordered-bottom overflow-inherit">
      <div className="tabs__wrap">
        <Nav tabs>
          {children.map((child, index) => (
            <NavItem key={uuid()}>
              <NavLink
                className={classnames({
                  active: activeTab === String(index + Number(ACTIVE_TAB.ONE)),
                })}
                onClick={() => {
                  nextStep(String(index + Number(ACTIVE_TAB.ONE)));
                }}
                disabled={!dto.objectives.length}
              >
                {child.props.title}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={activeTab}>
            {children[Number(activeTab - ACTIVE_TAB.ONE)]}
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
};

NavigationTabs.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  step: PropTypes.string.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  nextStep: PropTypes.func.isRequired,
};

export default withTranslation('common')(NavigationTabs);
